/**
 * Número de elementos por página en la tabla
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Tasa de interés diaria por defecto (0.3%)
 */
export const DEFAULT_DAILY_INTEREST_RATE = 0.003;

/**
 * Tipos de acciones para actualización de deuda
 */
export const DEBT_ACTION_TYPES = {
  PAY: 'pago',
  REGULARIZE: 'regulariza',
};

/**
 * Estados de procesamiento
 */
export const PROCESSING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  SUCCESS: {
    UPDATE_DEBT: 'Deuda actualizada exitosamente',
    SAVE_CHANGES: 'Cambios guardados correctamente',
  },
  ERROR: {
    UPDATE_DEBT: 'Error al actualizar la deuda',
    LOAD_DATA: 'Error al cargar los datos',
    INVALID_DATE: 'Fecha inválida',
    NO_SELECTION: 'Debe seleccionar al menos un cupón',
  },
  WARNING: {
    NO_CHANGES: 'No se han realizado cambios',
    UNSAVED_CHANGES: 'Hay cambios sin guardar',
  },
  INFO: {
    LOADING: 'Cargando datos...',
    NO_DATA: 'No se encontraron registros',
  },
};

/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  orden: { width: '15%' },
  suscriptores: { width: '25%' },
  cuotasDeuda: { width: '15%' },
  ajustesDeuda: { width: '15%' },
  total: { width: '10%' },
  editar: { width: '10%' },
  ver: { width: '10%' },
};

/**
 * Configuración de validaciones
 */
export const VALIDATION_RULES = {
  AMOUNT: {
    MIN: 0,
    MAX: 999999999,
  },
  DATE: {
    MIN_YEAR: 2000,
    MAX_YEAR: 2100,
  },
};

/**
 * Configuración de formatos
 */
export const FORMAT_CONFIG = {
  DATE: {
    INPUT: 'YYYY-MM-DD',
    DISPLAY: 'DD/MM/YYYY',
  },
  CURRENCY: {
    LOCALE: 'es-AR',
    CURRENCY: 'ARS',
    DECIMALS: 2,
  },
};

/**
 * Breakpoints para responsividad
 */
export const BREAKPOINTS = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
};

/**
 * Configuración de animaciones
 */
export const ANIMATION_CONFIG = {
  TRANSITION_DURATION: 300,
  HOVER_SCALE: 1.1,
  FADE_DURATION: 500,
};